export const INPUT_PLACEHOLDER = 'https://'
